<template>
    <v-tooltip top color="primary">
        <template v-slot:activator="{ on }">
            <v-img v-on="on" width="70" max-height="60" max-width="70":src="locale.image" class="mt-1"/>
        </template>
        <div>
            <div>Country: {{locale.country}}</div>
            <div>Language: {{locale.language}}</div>
            <div>Currency: {{locale.currency}}</div>
            <div>ISO code: {{locale.code}}</div>
            <div>ID: {{locale.id}}</div>
        </div>
    </v-tooltip>
</template>

<script>

    export default {

        props: {
            locale: {
                type: Object,
                required: true,
            },
        },
    }

</script>
